import { render, staticRenderFns } from "./SelfServiceForm.vue?vue&type=template&id=16aab5aa&"
import script from "./SelfServiceForm.vue?vue&type=script&lang=js&"
export * from "./SelfServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports